import routes from '@config/router'
import TOOLS from '@helpers/tools'

export default function previewDataLayer(cityId, match, locations, event) {
  let location = TOOLS.getCityState(locations, cityId)
  let city = undefined
  let state = undefined
  if (!!location && location.length > 0) {
    city = TOOLS.slugify(location[0].name)
    state = TOOLS.slugify(location[1].name)
  }
  let bi = {
    city: city,
    state: state,
    form: undefined,
    imoveis: undefined,
    searchParameter: undefined,
  }
  if (typeof window !== 'undefined') {
    if (!event) {
      window.dataLayer.push({
        event: 'pageview',
        pagepath: match.url,
        pageType: routes[0].routes.reduce((a, o) => {
          if (o.path === match.path) {
            a = TOOLS.slugify(o.type)
          }
          return a
        }, ''),
        ...bi,
      })
    } else if (!!event) {
      window.dataLayer.push({
        event: event,
        city: city,
        state: state,
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/BI/previewDataLayer.js